<div class="p-[36px] bg-neutral">
  <div class="font-termina text-[26px] mb-[14px]">Survey Respondent Already Exists</div>

  <div class="font-montserrat mb-[36px]">
    A survey respondent already exists with the {{ data.conflictType }} <b>{{ data.fieldValue }}</b>
    <br/>
    Would you like to assign this survey to the existing respondent?
  </div>

  <div class="flex items-center justify-end w-full gap-4">
    <div (click)="close()" class="text-right">
      <button class="font-termina bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-6 py-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-[14px] transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none">No, go back to details page</button>
    </div>
    <div (click)="continue()" class="text-right">
      <button class="font-termina bg-transparent border border-[var(--kek-purple)] text-[var(--kek-purple)] hover:bg-[var(--kek-purple)] hover:text-white px-6 py-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-[14px] transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none">Yes, assign to existing respondent</button>
    </div>
  </div>
</div>